"use client";

import { c as _c } from "react/compiler-runtime";
import { Minus, Plus } from "lucide-react";
import { useId, useRef, useState } from "react";
import type { FaqItem } from "./faq-items";
import { defaultFaqItems } from "./faq-items";
import { useFaqAnimation } from "./use-faq-animation";
export type { FaqItem } from "./faq-items";
export { defaultFaqItems } from "./faq-items";
export type FaqSectionProps = {
  tag?: string;
  title?: string;
  items?: FaqItem[];
  isServicePage?: boolean;
};
export default function FaqSection(t0) {
  const $ = _c(23);
  const {
    tag: t1,
    title: t2,
    items: t3
  } = t0;
  const tag = t1 === undefined ? "FAQ" : t1;
  const title = t2 === undefined ? "As d\xFAvidas mais comuns sobre todo o processo de design de interface" : t2;
  const items = t3 === undefined ? defaultFaqItems : t3;
  const sectionRef = useRef(null);
  const baseId = useId();
  const [openIndex, setOpenIndex] = useState(null);
  useFaqAnimation(sectionRef);
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="hidden md:inline-flex absolute -top-1.75 -left-1.75 z-20 h-3 w-3 border border-gray-300 bg-gray-300" />;
    t5 = <span className="hidden md:inline-flex absolute -top-1.75 -right-1.75 z-20 h-3 w-3 border border-gray-300 bg-gray-300" />;
    t6 = <span className="hidden md:inline-flex absolute -bottom-1.75 -left-1.75 z-20 h-3 w-3 border border-gray-300 bg-gray-300" />;
    t7 = <span className="hidden md:inline-flex absolute -bottom-1.75 -right-1.75 z-20 h-3 w-3 border border-gray-300 bg-gray-300" />;
    $[0] = t4;
    $[1] = t5;
    $[2] = t6;
    $[3] = t7;
  } else {
    t4 = $[0];
    t5 = $[1];
    t6 = $[2];
    t7 = $[3];
  }
  let t8;
  if ($[4] !== tag) {
    t8 = <p className="tag">{tag}</p>;
    $[4] = tag;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== title) {
    t9 = <h2 className="title">{title}</h2>;
    $[6] = title;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t8 || $[9] !== t9) {
    t10 = <div className="faq-copy max-w-120">{t8}{t9}</div>;
    $[8] = t8;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== baseId || $[12] !== items || $[13] !== openIndex) {
    let t12;
    if ($[15] !== baseId || $[16] !== openIndex) {
      t12 = (item, index) => {
        const isOpen = openIndex === index;
        const triggerId = `${baseId}-faq-trigger-${index}`;
        const panelId = `${baseId}-faq-panel-${index}`;
        const Icon = isOpen ? Minus : Plus;
        return <div className={`faq-item border-b transition-colors duration-300 ${isOpen ? "border-primary-300" : "border-gray-300/70"}`} key={item.question}><button aria-controls={panelId} aria-expanded={isOpen} className="group flex w-full cursor-pointer items-center justify-between gap-6 py-6 text-left text-base leading-[1.35] font-medium text-white transition-colors duration-300 hover:text-primary-300 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-300 md:py-6.75" id={triggerId} onClick={() => setOpenIndex(isOpen ? null : index)} type="button"><span>{item.question}</span><Icon aria-hidden="true" className={`size-3.5 shrink-0 transition-colors duration-300 ${isOpen ? "text-primary-300" : "text-white group-hover:text-primary-300"}`} strokeWidth={2.2} /></button><section aria-labelledby={triggerId} className={`grid overflow-hidden transition-[grid-template-rows,opacity] duration-300 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`} id={panelId}><div className="min-h-0"><div className="pb-9 text-sm leading-[1.55] text-gray-400 md:text-[15px]">{item.answer}</div></div></section></div>;
      };
      $[15] = baseId;
      $[16] = openIndex;
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    t11 = items.map(t12);
    $[11] = baseId;
    $[12] = items;
    $[13] = openIndex;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <div className="faq-list md:pt-1">{t11}</div>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <section ref={sectionRef} className="md:container-padding relative border-t border-gray-300 text-white"><div className="container relative py-18 md:border-x md:border-gray-300 md:py-24 px-6 lg:px-18 xl:px-24">{t4}{t5}{t6}{t7}<div className="faq-animate-trigger grid lg:grid-cols-2 gap-10 xl:gap-32">{t10}{t12}</div></div></section>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}